import type { ExportFormat } from "../../../Utils/Export/types";

export const EXPORT_FORMAT_DISPLAY: Record<
  ExportFormat,
  { icon: string; title: string; description: string }
> = {
  xlsx: {
    icon: "/img/excel.svg",
    title: "Excel",
    description: "Spreadsheet · .xlsx",
  },
  docx: {
    icon: "/img/word.svg",
    title: "Word",
    description: "Document · .docx",
  },
  html: {
    icon: "/img/browser.svg",
    title: "HTML report",
    description: "Opens in your browser",
  },
};

/** Display order in export format pickers. */
export const EXPORT_FORMAT_ORDER: ExportFormat[] = ["xlsx", "docx", "html"];

/** Formats shown but not selectable; value is the hover tooltip. */
export const EXPORT_FORMAT_UNAVAILABLE: Partial<Record<ExportFormat, string>> = {};

/** Track (Improve) keeps Word disabled until its exporter is ready for production. */
export const TRACK_EXPORT_FORMAT_UNAVAILABLE: Partial<
  Record<ExportFormat, string>
> = {
  docx: "Temporarily under development",
};

export function getExportFormatUnavailableReason(
  format: ExportFormat,
  trackExport = false
): string | undefined {
  if (trackExport) {
    return (
      TRACK_EXPORT_FORMAT_UNAVAILABLE[format] ??
      EXPORT_FORMAT_UNAVAILABLE[format]
    );
  }
  return EXPORT_FORMAT_UNAVAILABLE[format];
}

export function isExportFormatAvailable(
  format: ExportFormat,
  trackExport = false
): boolean {
  return !getExportFormatUnavailableReason(format, trackExport);
}
